import * as io from 'io-ts';

export const anyObject = io.UnknownRecord;
export const nullableAnyObject = io.union([anyObject, io.null]);
